/*
 * Copyright (c) 2017, Globo.com <https://github.com/globocom/megadraft-table-plugin>
 *
 * License: MIT
 */

export default {
  PLUGIN_TYPE: 'table-plugin',
};
